import { Tile } from '#src/components/boards/HotStreakTile/Tile/index.tsx';
import {
  DiamondBaseColor,
  DiamondBasePosition,
} from '#src/components/boards/HotStreakTile/Tile/utils.ts';

type Props = {
  gold?: boolean;
};
export const ClaimableTile = ({ gold = false }: Props) => {
  return (
    <Tile
      color={gold ? DiamondBaseColor.gold : DiamondBaseColor.blue}
      position={DiamondBasePosition.up}
      floating
    />
  );
};
